<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="添加筛选条件"
        width="750px"
        append-to-body
        :before-close="handleClose">
        <div class="content">
            <div class="title-group pl20">
                <el-checkbox :indeterminate="indeterminate" v-model="checkAll" @change="handleCheckAll" class="mb20">全选</el-checkbox>
            </div>
            <div class="list-group pl40">
                <el-checkbox-group v-model="checkedList" @change="changeCheckedList">
                    <el-checkbox v-for="item in list" :label="item.name" :key="item.name" class="mb10">{{item.label}}</el-checkbox>
                </el-checkbox-group>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">确定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "FilterConfigModal",
        props:{
            list:Array,
        },
        data(){
            return {
                dialogVisible:false,
                indeterminate:false,
                checkAll: false,
                checkedList:[],
            }
        },
        methods:{
            showModal(){
                this.dialogVisible = true;
                this.checkedList = (this.list||[]).filter(item=>item.checked).map(item=>item.name);
                this.checkAll =  this.checkedList.length === this.list.length;
                this.indeterminate = this.checkedList.length > 0 && this.checkedList.length < this.list.length;
            },
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm() {
                this.checkedList = [];
                this.indeterminate = false;
                this.checkAll = false;
            },
            handleSubmit(){
                this.$emit('save',this.checkedList);
                this.dialogVisible = false;
            },
            handleCheckAll(val){
                this.checkedList = val ? this.list.map(item=>item.name) : [];
                this.indeterminate = false;
            },
            changeCheckedList(val){
                let checkedCount = val.length;
                this.checkAll = checkedCount === this.list.length;
                this.indeterminate = checkedCount > 0 && checkedCount < this.list.length;
            }
        }
    }
</script>

<style scoped>

</style>
